import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PageHeaderNew } from '@/components/ui';

export function SubTaskEditPage() {
  const navigate = useNavigate();
  const { subTaskId } = useParams();

  return (
    <div className="p-4 space-y-4 bg-slate-50 min-h-screen text-slate-900">
      <PageHeaderNew 
        title="Chỉnh sửa công việc con"
        subtitle={`Cập nhật thông tin công việc con #${subTaskId}`}
        backUrl={`/work-orders`}
      />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        <div className="lg:col-span-9 space-y-4">
           <div className="rounded-md border border-slate-100 bg-white p-4 h-64 flex items-center justify-center">
              <p className="sm:text-sm text-xs text-slate-400">Khung nhập liệu cơ bản (Đang xây dựng...)</p>
           </div>
        </div>
        <div className="lg:col-span-3 space-y-4">
           <div className="rounded-md border border-slate-100 bg-white p-4 h-64 flex items-center justify-center">
              <p className="sm:text-sm text-xs text-slate-400">Cài đặt nâng cao</p>
           </div>
        </div>
      </div>
    </div>
  );
}

export default SubTaskEditPage;
